import React from "react";
import Dashboard from "components/dashboard";
import { PageHeaderBar, PageSection } from "components/page";
import { ActionButtons } from "./list-page";
import { parsePage } from "components/table";
import CustomersPaginatedTable from "./table/table";

const CustomerListPage = ({ location: { search } }) => {
  return (
    <Dashboard>
      <PageHeaderBar title="app.page.customer.list" buttons={<ActionButtons />} />
      <PageSection hideBackground>
        <CustomersPaginatedTable page={parsePage({ queryParams: search })} pageName={"page"}/>
      </PageSection>
    </Dashboard>
  );
};

export default CustomerListPage;
